import { render } from "./Guias.vue?vue&type=template&id=42a927b4&scoped=true"
import script from "./Guias.vue?vue&type=script&lang=js"
export * from "./Guias.vue?vue&type=script&lang=js"

import "./Guias.vue?vue&type=style&index=0&id=42a927b4&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a927b4"]])

export default __exports__